/* eslint-disable */

import React, { Component } from 'react';
import Cropper from 'react-cropper';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Close from '../icons/internals/Close';
import Rolling from '../icons/internals/Rolling';
// import Add from '../icons/internals/Add';
import Error from '../icons/internals/Error';
import Folder from '../icons/internals/Folder';
import IconButton from '../button/IconButton';
import Button from '../button/Button';
import Modal from '../modal/Modal';
import Radio from '../radio/Radio';
import RadioGroup from '../radio/RadioGroup';
import Input from '../input/Input';
import attrAccept from './accept';
import 'cropperjs/dist/cropper.css';

const now = Date.now();
let fileId = 0;

function getUid() {
  return `ne-upload-${now}-${++fileId}`;
}
const isImage = file => file && file.type.includes('image');

const previewFile = (file, cb) => {
  const reader = new FileReader();
  reader.addEventListener(
    'load',
    () => {
      file.url = reader.result;
      cb && cb(file.url);
    },
    false,
  );

  if (file) {
    reader.readAsDataURL(file);
  }
};

export default class Upload extends Component {
  static propTypes = {
    style: PropTypes.object,
    prefixCls: PropTypes.string,
    className: PropTypes.string,
    /** 是否多选 */
    multiple: PropTypes.bool,
    /** 是否禁用 */
    disabled: PropTypes.bool,
    /** 接受上传的文件类型 */
    accept: PropTypes.string,
    children: PropTypes.any,
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    /** 上传文件之前的钩子，参数为上传的文件，若返回 false 则停止上传。支持返回一个 Promise 对象 */
    beforeUpload: PropTypes.func,
    /** 默认文件（非受控使用) */
    defaultFiles: PropTypes.array,
    /** 文件列表渲染方法 */
    fileRender: PropTypes.func,
    /** 单图模式 */
    avatar: PropTypes.bool,
    radioDefault: PropTypes.string,
  };

  static defaultProps = {
    prefixCls: 'ne-upload',
    defaultFiles: [],
  };

  static getDerivedStateFromProps(props, state) {
    const { defaultFiles } = props;
    if (!state.isControlled && defaultFiles !== state.prevFiles) {
      return {
        files: defaultFiles,
        prevFiles: defaultFiles,
      };
    }
    return null;
  }

  constructor(props) {
    super();
    const { files, defaultFiles, radioDefault } = props;
    this.isControlled = files != null;
    this.state = {
      isControlled: this.isControlled,
      files: defaultFiles,
      prevFiles: defaultFiles,
      showModal: false,
      src: '',
      cropResult: null,
      currentID: '',
      cropperWidth: radioDefault ? parseInt(radioDefault.split('*')[0], 10) : 100,
      cropperHeight: radioDefault ? parseInt(radioDefault.split('*')[1], 10) : 100,
      cropperMode: radioDefault || 'custimage'
    };
  }

  componentDidMount() {
    this.monuted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handleChange = e => {
    const { files } = e.target;
    this.uploadFiles(files);
    try {
      e.target.value = null;
    } catch {
      return e;
    }
  };

  previewImage = (file) => {
    this.setState({
      previewModal: true,
      currentID: file.uid,
      src: file.url
    });
  };

  cropperImage = (file) => {
    this.setState({
      showModal: true,
      currentID: file.uid,
      src: file.url
    });
  };

  handleClick = () => {
    const e = this.fileInput;
    if (!e) {
      return;
    }
    e.click();
  };

  handleKeyDown = e => {
    if (e.key === 'Enter') {
      this.onClick();
    }
  };

  handleFileDrop = e => {
    e.preventDefault();
    const { accept } = this.props;
    if (e.type === 'dragover') {
      return;
    }
    const files = Array.from(e.dataTransfer.files).filter(file => attrAccept(file, accept));
    this.uploadFiles(files);
  };

  uploadFiles = files => {
    const { avatar, single } = this.props;
    Array.from(files)
      .slice(0, avatar || single ? 1 : files.length)
      .forEach(file => {
        file.uid = getUid();
        file.loading = true;
        if (isImage(file)) {
          previewFile(file, (fileUrl) => {
            this.setState({src: fileUrl});
            return this.forceUpdate()
          });
        }
        setTimeout(() => {
          this.upload(file);
        }, 0);
      });
  };

  upload = file => {
    const { beforeUpload, onChange, avatar, single, files } = this.props;
    const { files: stateFiles } = this.state;
    const oldFiles = this.isControlled ? files : stateFiles;
    const before = beforeUpload ? beforeUpload(file, oldFiles) : file;
    if (!before) {
      return;
    }
    if (!before.then) {
      file.loading = false;
    }
    if (onChange && (this.isControlled || !before.then)) {
      onChange(avatar || single ? [file] : oldFiles.concat([file]), file);
    }
    if (!this.isControlled) {
      this.setState(state => ({
        files: avatar || single ? [file] : state.files.concat([file]),
      }));
    }
    if (before.then) {
      return before
        .then(processedFile => {
          if (!this.monuted) {
            return;
          }
          const { onChange } = this.props;
          const files = this.isControlled ? this.props.files : this.state.files;
          processedFile.uid = file.uid;
          processedFile.loading = false;
          if (files.find(oldFile => oldFile.uid === file.uid)) {
            if (onChange) {
              const newList = files.map(oldFile =>
                oldFile.uid === file.uid ? processedFile : oldFile,
              );
              onChange(
                this.isControlled
                  ? newList
                  : newList.filter(file => file && !file.loading && !file.fail),
                processedFile,
              );
            }
            if (!this.isControlled) {
              this.setState(state => ({
                files: state.files.map(oldFile =>
                  oldFile.uid === file.uid ? processedFile : oldFile,
                ),
              }));
            }
          }
        })
        .catch(processedFile => {
          if (!this.monuted) {
            return;
          }
          const { avatar, single } = this.props;
          const files = this.isControlled ? this.props.files : this.state.files;
          processedFile.fail = true;
          processedFile.loading = false;
          processedFile.uid = file.uid;
          if (files.find(oldFile => oldFile.uid === file.uid)) {
            const newList = files.map(oldFile =>
              oldFile.uid === file.uid ? processedFile : oldFile,
            );
            if (onChange && this.isControlled) {
              onChange(newList, processedFile);
            }
            if (!this.isControlled) {
              if (
                (avatar || single) &&
                oldFiles.filter(file => file && !file.loading && !file.fail).length
              ) {
                onChange([], null);
              }
              this.setState(state => ({
                files: state.files.map(oldFile =>
                  oldFile.uid === file.uid ? processedFile : oldFile,
                ),
              }));
            }
          }
        });
    }
  };

  handleDelete = uid => () => {
    const { onChange } = this.props;
    const files = this.isControlled ? this.props.files : this.state.files;
    if (onChange) {
      if (!this.isControlled) {
        const target = files.find(file => file && !file.loading && !file.fail && file.uid === uid);
        if (target) {
          onChange(files.filter(file => file !== target && !file.fail && !file.loading), target);
        }
      } else {
        const target = files.find(file => file && file.uid === uid);
        onChange(files.filter(file => file !== target), target);
      }
    }
    if (!this.isControlled) {
      this.setState(state => ({
        files: state.files.filter(file => file.uid !== uid),
      }));
    }
  };

  getInput = node => {
    this.fileInput = node;
  };

  itemRender = file => {
    const { prefixCls, avatar, single, gallery, accept, multiple, disabled } = this.props;
    return (
      <div
        key={file.uid}
        className={classNames(`${prefixCls}-list-item`, {
          [`${prefixCls}-list-item-loading`]: file.loading,
          [`${prefixCls}-list-item-fail`]: file.fail,
          [`${prefixCls}-list-item-success`]: !file.loading && !file.fail,
          [`${prefixCls}-list-item-gallery`]: gallery,
          [`${prefixCls}-list-item-single`]: avatar || single,
        })}>
        {!disabled && (avatar || single) ? (
          <div>
            <div>
              <div className={`${prefixCls}-cropper-mask`} onClick={this.handleClick}>
                <input
                  type="file"
                  ref={this.getInput}
                  style={{ display: 'none' }}
                  accept={accept}
                  multiple={!(avatar || single) && multiple}
                  onChange={this.handleChange}/>
                重新上传
              </div>
              <div className={`${prefixCls}-mask`} onClick={() => {this.cropperImage(file)}}>裁剪</div>
            </div>
            <div className={`${prefixCls}-preview-btn`} onClick={() => {this.previewImage(file)}}>预览</div>
          </div>
        ) : null}
        <div className={`${prefixCls}-list-item-container`}>
          {file.loading ? (
            <Rolling spin className={`${prefixCls}-status`} />
          ) : file.fail ? (
            <Error className={`${prefixCls}-status`} />
          ) : (avatar || single || gallery) && file.url ? (
            <img src={file.url} alt="预览" className={`${prefixCls}-status ${prefixCls}-preview`} />
          ) : (
            <Folder className={`${prefixCls}-status`} />
          )}
        </div>
        {avatar || single ? null : <span className={`${prefixCls}-file-name`}>{file.name}</span>}
        <IconButton
          variant="text"
          onClick={this.handleDelete(file.uid)}
          className={`${prefixCls}-delete`}>
          <Close size="small" />
        </IconButton>
      </div>
    );
  };

  cropImage = (callback) => {
    if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
      return;
    }

    const cropBoxData = this.cropper.getCropBoxData();
    const canvasData = this.cropper.getCanvasData();
    const left = cropBoxData.left - canvasData.left;
    const top = cropBoxData.top - canvasData.top;
    const width = cropBoxData.width;
    const height = cropBoxData.height;

    const { cropperWidth, cropperHeight } = this.state;

    this.setState({
      cropResult: this.cropper.getCroppedCanvas({ width: cropperWidth, height: cropperHeight }).toDataURL(),
      left,
      top,
      width,
      height
    }, () => {
      if (typeof callback === "function")
        callback();
    });
  }

  cropImageSure = () => {
    const mine = this;
    this.cropImage(() => {
      const { cropResult, currentID } = mine.state;
      const { cropSure, onChange, radioDefault } = mine.props;
      const files = mine.isControlled ? mine.props.files : mine.state.files;
      mine.setState({
        showModal: false,
        cropperWidth: radioDefault ? parseInt(radioDefault.split('*')[0], 10) : 100,
        cropperHeight: radioDefault ? parseInt(radioDefault.split('*')[1], 10) : 100,
        cropperMode: radioDefault || 'custimage'
      });
      if (cropSure) cropSure(cropResult).then(res => {
        if (onChange) {
          files.filter(file => {
            if (file.uid == currentID) {
              Object.assign(file, res);
            }
          });
          onChange(files);
        }
      });
    });
  }

  cropImageCancel = () => {
    const { radioDefault } = this.props;
    this.setState({
      showModal: false,
      cropResult: null,
      currentID: '',
      cropperWidth: radioDefault ? parseInt(radioDefault.split('*')[0], 10) : 100,
      cropperHeight: radioDefault ? parseInt(radioDefault.split('*')[1], 10) : 100,
      cropperMode: radioDefault || 'custimage'
    });
  }

  previewImageCancel = () => {
    const { radioDefault } = this.props;
    this.setState({
      previewModal: false
    });
  }

  changeSize = (value) => {
    const { radioDefault } = this.props;
    let cropperWidth = radioDefault ? parseInt(radioDefault.split('*')[0], 10) : 100;
    let cropperHeight = radioDefault ? parseInt(radioDefault.split('*')[1], 10) : 100;
    if (value !== 'custimage') {
      cropperWidth = parseInt(value.split('*')[0], 10);
      cropperHeight = parseInt(value.split('*')[1], 10);
    }
    this.setState({
      cropperMode: value,
      cropperWidth,
      cropperHeight
    });
  }

  setCropperSizeWidth = (e) => {
    this.setState({
      cropperWidth: parseInt(e.target.value || 0, 10)
    });
  }
  
  setCropperSizeHeight = (e) => {
    this.setState({
      cropperHeight: parseInt(e.target.value || 0, 10)
    });
  }

  render() {
    const {
      prefixCls,
      className,
      disabled,
      multiple,
      accept,
      gallery,
      avatar,
      single,
      cropperpreview,
      children,
      fileRender,
      files: propsFiles,
      radioList,
      radioDefault,
    } = this.props;
    const { files: stateFiles, showModal, previewModal, src, cropResult, cropperHeight, cropperWidth, cropperMode } = this.state;
    const files = this.isControlled ? propsFiles : stateFiles;
    const classes = classNames(`${prefixCls}-trigger`, className, {
      [`${prefixCls}-disabled`]: disabled,
      [`${prefixCls}-gallery`]: gallery,
      [`${prefixCls}-single`]: avatar || single,
    });
    const listClasses = classNames(`${prefixCls}-list`);
    const events = disabled
      ? {}
      : {
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown,
          onDrop: this.handleFileDrop,
          onDragOver: this.handleFileDrop,
          tabIndex: '0',
        };
    const render = fileRender || this.itemRender;
    const button = (
      <div {...(files.length && (avatar || single) ? {} : events)} className={classes}>
        <input
          type="file"
          ref={this.getInput}
          style={{ display: 'none' }}
          accept={accept}
          multiple={!(avatar || single) && multiple}
          onChange={this.handleChange}/>
        {children}
      </div>
    );

    const uploadItem = (
      <div
        className={classNames(`${prefixCls}-list-item`, `${prefixCls}-list-item-upload`)}
        {...(files.length && (avatar || single) ? {} : events)}>
        <input
          type="file"
          ref={this.getInput}
          style={{ display: 'none' }}
          accept={accept}
          multiple={!(avatar || single) && multiple}
          onChange={this.handleChange}/>
        {children}
      </div>
    );
    const list =
      avatar || single ? (
        files.length ? (
          render(files[0], files, this.handleDelete(files[0].uid), events)
        ) : (
          uploadItem
        )
      ) : (
        <div className={listClasses}>
          {files.map(file => render(file, files, this.handleDelete(file.uid), events))}
          {gallery ? uploadItem : null}
        </div>
      );
    return (<div>
      {
        gallery || avatar || single ? (
          <div className={prefixCls}>{list}</div>
        ) : (
          <div className={prefixCls}>
            {button}
            {list}
          </div>
        )
      }
      <Modal
          size='large'
          animationName='scale'
          isOpen={showModal}
          onClose={this.cropImageCancel}>
          <div>
              <div style={{marginBottom: 5}}>
                <RadioGroup onChange={(e, value) => this.changeSize(value)} defaultValue={radioDefault || 'custimage'}>
                  {radioList}
                  <Radio label="自定义" value="custimage" key="custimage" />
                </RadioGroup>
                {
                  cropperMode === 'custimage' ? <div>
                    width:<Input size="small" style={{marginRight: 5}} placeholder="width" value={cropperWidth} onChange={this.setCropperSizeWidth} />
                    height:<Input size="small" placeholder="height" value={cropperHeight} onChange={this.setCropperSizeHeight} />
                  </div> : ''
                }
              </div>
              <div>
                  <Cropper
                      aspectRatio={cropperWidth / cropperHeight}
                      style={{ height: 400 }}
                      guides
                      dragMode="move"
                      src={src}
                      ref={cropper => { this.cropper = cropper; }}
                  />
                  {
                    cropperpreview ? <div className="box" style={{ maxHeight: 400, padding: 10 }}>
                        <div style={{marginBottom: 10}}>预览</div>
                        {
                            cropResult ? <img style={{ maxHeight: 400 }} src={cropResult} alt="预览" /> : ''
                        }
                    </div> : ''
                  }
              </div>
              <div style={{marginTop: 10}}>
                  { cropperpreview ? <Button variant="contained" color="success" onClick={this.cropImage} style={{marginRight: 5}}>预览</Button> : '' }
                  <Button variant="contained" color="success" onClick={this.cropImageSure} style={{marginRight: 5}}>确定</Button>
                  <Button variant="contained" color="secondary" onClick={this.cropImageCancel} style={{marginRight: 5}}>取消</Button>
              </div>
          </div>
        </Modal>

        <Modal
          size='large'
          animationName='scale'
          isOpen={previewModal}
          onClose={this.previewImageCancel}>
            { src ? <img style={{ maxHeight: 400 }} src={src} alt="预览" /> : '' }
        </Modal>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/upload/Upload.jsx